import { fromJS } from 'immutable/dist/immutable';
import { basicSort } from '../../../../util/sortUtils';
import { refColumns, refSort } from '../../../InfoReduxConstant';

export const CLEAR_VOLCANO_EVENT_INFO = 'CLEAR_VOLCANO_EVENT_INFO';

export const GET_VOLCANO_EVENT_INFO_REFERENCES_REQUEST = 'GET_VOLCANO_EVENT_INFO_REFERENCES_REQUEST';
export const GET_VOLCANO_EVENT_INFO_REFERENCES_SUCCESS = 'GET_VOLCANO_EVENT_INFO_REFERENCES_SUCCESS';
export const GET_VOLCANO_EVENT_INFO_REFERENCES_FAILURE = 'GET_VOLCANO_EVENT_INFO_REFERENCES_FAILURE';

export const GET_VOLCANO_EVENT_INFO_REQUEST = 'GET_VOLCANO_EVENT_INFO_REQUEST';
export const GET_VOLCANO_EVENT_INFO_SUCCESS = 'GET_VOLCANO_EVENT_INFO_SUCCESS';
export const GET_VOLCANO_EVENT_INFO_FAILURE = 'GET_VOLCANO_EVENT_INFO_FAILURE';

export const VOLCANO_EVENT_INFO_REFERENCE_SORT = 'VOLCANO_EVENT_INFO_REFERENCE_SORT';

export const VOLCANO_EVENT_INFO_TOGGLE_COLUMN = 'VOLCANO_EVENT_INFO_TOGGLE_COLUMN';

const initialState = fromJS({
  fetchedVolcanoEvent: false,
  volcanoEvent: {},
  fetchedReferences: false,
  references: [],

  sort: refSort,
  visibleColumns: refColumns,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const volcanoEventInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_VOLCANO_EVENT_INFO:
      return initialState;

    case VOLCANO_EVENT_INFO_REFERENCE_SORT:
      return state.merge(fromJS({
        references: basicSort(action.sort, state.get('references')),
        sort: action.sort,
      }));

    case GET_VOLCANO_EVENT_INFO_REFERENCES_REQUEST:
      return state.set('fetchedReferences', false);
    case GET_VOLCANO_EVENT_INFO_REFERENCES_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case GET_VOLCANO_EVENT_INFO_REFERENCES_FAILURE:
      return state.set('fetchedReferences', true);

    case GET_VOLCANO_EVENT_INFO_REQUEST:
      return state.set('fetchedVolcanoEvent', false);
    case GET_VOLCANO_EVENT_INFO_SUCCESS:
      return state.merge(fromJS({
        fetchedVolcanoEvent: true,
        volcanoEvent: action.response,
      }));
    case GET_VOLCANO_EVENT_INFO_FAILURE:
      return state.set('fetchedVolcanoEvent', true);

    case VOLCANO_EVENT_INFO_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
